<template>
  <nav
    class="c-section-nav"
  >
    <button
      v-if="selectedSection !== 'all'"
      @click="close()"
      @keyup.enter="close()"
      type="button"
      class="c-btn c-btn--primary c-btn--has-icon"
      aria-label="Tilbake til oversikt"
    >
      <icon-left
        class="c-btn__icon c-btn__icon--left c-btn__icon--alignment"
      />
      Oversikt
    </button>
    <transition
      v-if="showSectionName === true"
      name="section-nav-fade"
      mode="out-in"
    >
      <p class="c-section-nav__header c-section-nav__header--big">
        {{ name }}
      </p>
    </transition>
    <transition
      v-else
      name="section-nav-fade"
      mode="out-in"
    >
      <select-section
        class="c-select c-select--center c-select--big c-section-nav__header c-section-nav__header--big"
      />
    </transition>
  </nav>
</template>

<script>
import { EventBus, } from '@/event-bus.js';

// Data models
import Section from '@/models/Section';
import Illustration from '@/models/Illustration';

// Components
import SelectSection from '@/components/SelectSection.vue';
import IconLeft from '@/components/icons/IconLeft.vue';


export default {
  name: 'SectionNavigation',
  components: {
    SelectSection,
    IconLeft,
  },
  data() {
    return {
      hoveredSectionId: 0,
      showSectionName: false,
    };
  },
  computed: {
    name() {
      let name = '';
      if (this.showSectionName === true) {
        const section = Section.query()
          .with('availability')
          .whereId(this.hoveredSectionId)
          .first();
        if (section.availability.slug === 'for-sale') {
          name = section.name;
        } else {
          name = section.name + ' – ' + section.availability.name;
        }
        return name;
      } else {
        return name;
      }
    },
    selectedSection() {
      return this.$store.state.entities.sections.selectedSection;
    },
  },
  created() {
    EventBus.$on('section-focus', focus => {
      if (focus.name) {
        this.showSectionName = focus.hasFocus;
        this.hoveredSectionId = focus.id;
      } else {
        this.showSectionName = false;
        this.hoveredSectionId = 0;
      }
    });
  },
  methods: {
    close() {
      Section.commit(state => {
        state.selectedSection = 'all';
      });
      Illustration.commit(state => {
        state.currentSection = 'all';
      });
      localStorage.setItem('selectedSection', 'all');
    },
  },
};
</script>
